import {useAppSelector} from '@/hooks';
import type {BrandsLoadingState} from '@Components/mystuff-brands/brand-kits.types';

export const useBrandsLoadingState = (): BrandsLoadingState => {
  return useAppSelector(({brands}) => {
    return brands.brandsLoadingState;
  });
};
